module.exports = __webpack_public_path__ + "img/top_logo.4696fff0.png";